import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { FETCH_ADS, REMOVE_AD, REMOVE_AD_FAIL, REMOVE_AD_SUCCESS } from '../redux/Ads';
import { DELETE } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';

function* removeAdFlow({ payload, }) {
  try {
    const endpoint = `${apiRoot}/ads/${payload}`;
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: DELETE, endpoint, });
    yield put(REMOVE_AD_SUCCESS(response));
    yield put(FETCH_ADS());
  } catch (error) {
    yield put(REMOVE_AD_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* RemoveAd() {
  yield takeLatest(REMOVE_AD, removeAdFlow);
}
